
import { UsersIcon as HeroUsersIcon } from '@heroicons/react/24/outline';
export const UsersIcon = HeroUsersIcon;
